<template>
    <div class="report-widget-container">
        <div class="report-widget-loading-overlay" v-if="runningReport">
            <v-icon>mdi-refresh</v-icon>
        </div>

        <div class="ag-grid-container" :class="{hide: ($props.widgetObj.showTypeNum !== 0)}">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="dataReady && !noBackendData"
                :gridOptions="gridOptions"
                :rowSelection="'multiple'"
                :groupHeaders="true"
                :headerHeight="50"
                :scrollbarWidth="20"
                :getRowHeight="getRowHeight"
                :sendToClipboard="sendToClipboard"
                :copyHeadersToClipboard="true">
            </ag-grid-vue>
        </div>


        <div class="report-chart-settings-container" :class="{hide: ($props.widgetObj.showTypeNum !== 2)}" v-if="dataReady && !noBackendData">
            <report-widget-chart :transpose="true" :reportDetails="$props.widgetObj.reportDetails" :reportResults="reportResults" :datetimeColumn="$props.widgetObj.datetimeColumn" :savedChartOptions="$props.widgetObj.chartOptions" :refeshChartSettings="refeshChartSettings" :refreshChartRun="refreshChartRun" @build="buildChart"></report-widget-chart>
        </div>


        <highcharts :options="$props.widgetObj.chartOptions" v-if="$props.widgetObj.showTypeNum == 1 && $props.widgetObj.chartOptions.chart && !noBackendData"></highcharts>
        <span class="no-chart-text" v-if="$props.widgetObj.showTypeNum == 1 && !$props.widgetObj.chartOptions.chart">No Chart Configured</span>
        <div class="threshold-exceeded" title="High Threshold Exceeded" v-if="highThresholdExceeded">
            <v-icon :color="$props.widgetObj.chartOptions.yAxis.plotLines[1].color" large>mdi-alert-circle</v-icon>
        </div>
        <div class="threshold-exceeded" :class="{'mr-9': (lowThresholdExceeded && highThresholdExceeded)}" title="Low Threshold Exceeded" v-if="lowThresholdExceeded">
            <v-icon :color="$props.widgetObj.chartOptions.yAxis.plotLines[0].color" large>mdi-alert-circle</v-icon>
        </div>
        

        <div class="report-show-select-container" :class="{active: showDisplayType}" v-if="!noBackendData">
            <v-btn-toggle v-model="$props.widgetObj.showTypeNum" mandatory>
                <v-btn color="#c42111"><v-icon>mdi-table-large</v-icon></v-btn>
                <v-btn color="#c42111"><v-icon>mdi-chart-bar</v-icon></v-btn>
                <v-btn color="#c42111"><v-icon>mdi-table-edit</v-icon></v-btn>
            </v-btn-toggle>
        </div>

        <div class="no-backend-data-container" v-if="noBackendData">
            <span>Report Data Unavailable</span>
        </div>

        <div class="no-backend-data-container" v-if="insufficientPermissions">
            <span>Insufficient Report Permissions</span>
        </div>

    </div>
</template>

<script>
import ReportChart from '@/components/Reports/ReportChart';
import ReportWidgetChart from '@/components/TelsasoftDashboard/ReportWidgetChart';

import { alarmPipeFilterParams, alarmDateFilterParams } from "@/components/Alarms/AlarmFuncs";
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
export default {
    name: 'ReportWidget',
    props: ['widgetObj', 'widgetCommand'],
    components: {
        'ag-grid-vue': AgGridVue,
        ReportChart,
        ReportWidgetChart
    },
    data: () => ({
        //showGrid: false,
        runningReport: false,
        gridOptions: null,
        reportResults: null,
        conditionalFormatting: [],
        selectedReportView: null,
        gridSmallMode: false,
        dataReady: false,
        showDisplayType: false,
        refeshChartSettings: 0,
        refreshChartRun: 0,
        timeoutFunc: null,
        noBackendData: false,
        insufficientPermissions: false
    }),

    computed: {
        lowThresholdExceeded: function() {
            return (this.$props.widgetObj.showTypeNum == 1 && this.$props.widgetObj.chartOptions.chart && this.$props.widgetObj.chartOptions.lowThresExceeded);
        },
        highThresholdExceeded: function() {
            return (this.$props.widgetObj.showTypeNum == 1 && this.$props.widgetObj.chartOptions.chart && this.$props.widgetObj.chartOptions.highThresExceeded);
        }

    },

    methods: {
        runReport: function(refresh) {
            if(this.insufficientPermissions) {
                return;
            }
            let route = `${TELSA.apiHost}report/run`;



            let reportParams = JSON.parse(JSON.stringify(this.$props.widgetObj.reportDetails.report_params));
            let dateParam;
            for(let param of reportParams) {
                if(param.rpt_param_type == "date_range") {
                    dateParam = param;
                    break;
                }
            }

            let originalStartDate = TELSA.moment(dateParam.selectedValue.split(' ')[0]);
            let originalEndDate = TELSA.moment(dateParam.selectedValue.split(' ')[1]);
            let todayDate = TELSA.moment(TELSA.moment().tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD'));
            let originalRunDate = this.$props.widgetObj.reportDetails.original_run_date;
            let daysPast = todayDate.diff(originalRunDate, 'days');
            let newEndDate = originalEndDate.clone().add(daysPast, 'days');
            let newStartDate = originalStartDate.clone().add(daysPast, 'days');

            // We always do date-windowed params for a report widget
            dateParam.selectedValue = `${newStartDate.format('YYYY-MM-DD')} ${newEndDate.format('YYYY-MM-DD')}`;
            dateParam.humanText = `${newStartDate.format('YYYY-MM-DD')} to ${newEndDate.add(-1, 'days').format('YYYY-MM-DD')}`;

            let reportName = this.$props.widgetObj.reportDetails.report_name;
            //let reportParams = this.$props.widgetObj.reportDetails.report_params.map(p => {return p.selectedValue});
            reportParams = reportParams.map(p => {return p.selectedValue});
            this.runningReport = true;
            return this.$http.post(route, {args: {report: reportName, params: reportParams, humanParams: '', noCache: true, dashboard: true}}).then(response => {
                let results = response.body;
                if(results == "no_dashboard_report_results") {
                    // The supervisor labord program hasn't yet even once ran the report. Should tell user to wait a little bit.
                    this.runningReport = false;
                    if(!refresh) {
                        this.noBackendData = true; // if its a refresh, then let them keep viewing the previous returned data. 
                    }
                    this.$emit('complete');
                    return;
                }
                
                if(!this.$props.widgetObj.datetimeColumn) {
                    this.$props.widgetObj.datetimeColumn = this.getDatetimeColumn(results.data.data[0]);
                }
                if(!refresh || !this.reportResults || this.noBackendData) {
                    // Initial report run on mounted
                    this.noBackendData = false;
                    this.reportResults = results.data;
                    this.buildAgGrid();
                }
                else {
                    // Report refresh. Maintain current grid/chart filters/settings
                    this.reportResults.data = results.data.data;
                    this.gridOptions.rowData = this.reportResults.data;
                    this.gridOptions.api.setRowData(this.reportResults.data);
                    this.applyGridConfig();
                    this.refreshChartRun++;
                    //this.$emit('complete');
                }
                this.$emit('complete');
                this.runningReport = false;
            });
        },

        buildAgGrid: function() {
            //this.showGrid = false;
            this.dataReady = false;

            this.gridOptions = {};
            this.gridOptions.rowData = this.reportResults.data;
            this.gridOptions.columnDefs = this.createColumnDefs(this.reportResults.cols);
            this.gridOptions.suppressFieldDotNotation = true;
            // This stops all the console warnings from having my own custom conditional formatting properties on the colDef objects
            this.gridOptions.suppressPropertyNamesCheck = true;

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.api.autoSizeColumns();
                self.defaultColumnState = self.gridOptions.columnApi.getColumnState();
                self.applyGridConfig();


                if(self.$props.widgetObj.showTypeNum == 1) {
                    // If they had built a chart in the past and the current view is for a chart, then we
                    // need to trigger a chart refresh.
                    self.refreshChartRun++;
                }
            }

            this.getRowHeight = function(params) {
                return (self.gridSmallMode ? 24 : 40);
            };

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            //this.showGrid = true;
            this.dataReady = true;
        },

        createColumnDefs: function(cols) {
            let self = this;
            let columnDefs = []
            for(let col of cols) {
                let just = 'center';
                if(col.justs == 'L') {
                    just = 'left';
                }
                else if(col.justs == 'R') {
                    just = 'right';
                }
                let filter = (col.type == "f" || col.type == "i") ? "number" : "text";
                let filterParams = alarmPipeFilterParams;
                let test = self.reportResults.data.length ? self.reportResults.data[0][col.name] : null
                if((TELSA.moment(test, 'YYYY-MM-DD', true).isValid()) 
                    || (TELSA.moment(test, 'YYYY-MM-DD HH:mm:ss', true).isValid())
                    || (TELSA.moment(test, 'HH:mm:ss', true).isValid())
                    || (TELSA.moment(test, 'YYYY-MM-DD HH:mm:ssZ', true).isValid())
                    || (TELSA.moment(test, 'YYYY-WW', true).isValid())) {
                        filter = 'date';
                        filterParams = alarmDateFilterParams;
                }

                columnDefs.push({
                    headerName: col.name,
                    field: col.name,
                    filter: filter,
                    filterParams: filterParams,
                    headerTooltip: col.name,
                    width: 150,
                    hide: (col.width == 0 ? true : false),
                    sortable: true,
                    cellStyle: function(params) {
                        let cf = self.conditionalFormatting.find(cf => {
                            return cf.colId == col.name;
                        });
                        let conditionalFormattingRules = cf ? cf.rules : [];
                        let ruleToApply = self.getConditionalFormattingRuleToApply(conditionalFormattingRules, params.data[col.name]);
                        if(ruleToApply) {
                            return {'padding-top': `${self.gridRowPadding}`, 'text-align': just, 'background-color': ruleToApply.color, 'color': ruleToApply.textColor}
                        }
                        else {
                            return {'padding-top': `${self.gridRowPadding}`, 'text-align': just}
                        }
                    },
                    valueGetter: function(params) {
                        // This is to get agGrid to sort numbers correctly
                        if(!isNaN(Number(String(params.data[col.name]).replace(/,/g, ''))) && params.data[col.name] !== "") {
                            return Number(String(params.data[col.name]).replace(/,/g, ''));
                        }
                        return params.data[col.name];
                    },
                    conditionalFormattingAllowed: (col.type == "f" || col.type == "i"),
                })
            }
            return columnDefs;
        },

        getConditionalFormattingRuleToApply: function(conditionalFormattingRules, value) {
            let ruleToApply = null;
            let fValue = value.replace(/,/g, '');
            for (let rule of conditionalFormattingRules) {
                if(rule.condition == 'lt' && Number(fValue) < Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'lte' && Number(fValue) <= Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'eq' && Number(fValue) == Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'gt' && Number(fValue) > Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'gte' && Number(fValue) >= Number(rule.value)) {
                    ruleToApply = rule;
                }

                if(ruleToApply && ruleToApply.stopIfTrue) {
                    break;
                }
            }
            return ruleToApply;
        },

        applyGridConfig: function() {
            // If there is no report view then we're done.
            if(this.selectedReportView) {
                //this.gridOptions.columnApi.setColumnState(this.selectedReportView.view_grid_config.gridData);
                if(!this.gridOptions.columnApi.setColumnState(this.selectedReportView.view_grid_config.gridData)) {
                    // A new column exists that isn't in the saved grid config
                    for(let c of this.reportResults.cols) {
                        if(!this.selectedReportView.view_grid_config.gridData.some(dataCol => {
                            return c.name == dataCol.colId;
                        })) {
                            this.gridOptions.columnApi.setColumnVisible(c.name, true);
                        }
                    }
                }
                this.gridOptions.api.setFilterModel(this.selectedReportView.view_grid_config.filterData);
                this.gridOptions.api.setSortModel(this.selectedReportView.view_grid_config.sortData);
                this.gridSmallMode = this.selectedReportView.view_grid_config.gridSmallMode ? this.selectedReportView.view_grid_config.gridSmallMode : false;
                this.conditionalFormatting = JSON.parse(JSON.stringify(this.selectedReportView.view_grid_config.conditionalFormatting ? this.selectedReportView.view_grid_config.conditionalFormatting : []));
            }
            // we need to trigger the UI to change to compact/comfortable mode.
            this.gridOptions.api.resetRowHeights();
            this.gridOptions.api.redrawRows();

            // Set filtered data
            this.resetFilteredResults();

            TELSA.loading(false);
        },

        toggleGridSmallMode: function() {
            this.gridSmallMode = !this.gridSmallMode;
            this.gridOptions.api.resetRowHeights();
            this.gridOptions.api.redrawRows();
        },

        clearView: function() {
            this.gridOptions.columnApi.setColumnState(this.defaultColumnState);
            this.gridOptions.api.setFilterModel(null);
            this.gridOptions.api.setSortModel(null);
            this.selectedReportView = null;
            this.conditionalFormatting = [];
            // Rebuild grid to apply the removal of conditional formatting
            this.gridOptions.api.redrawRows();
        },

        sendToClipboard: function(params) {
            navigator.clipboard.writeText(params.data);
        },

        resetFilteredResults: function() {
            let filteredData = [];
            this.gridOptions.api.forEachNodeAfterFilterAndSort((node, idx) => {
                filteredData.push(node.data);
            });
            this.reportResults.data = filteredData;
            this.refeshChartSettings++;
        },

        buildChart: function(chartOptions, refresh) {
            //this.chartOptions = chartOptions;
            this.$props.widgetObj.chartOptions = chartOptions;
            if(!refresh) {
                this.$props.widgetObj.showTypeNum = 1;
            }
        },

        getDatetimeColumn: function(dataRowObj) {
            if(dataRowObj) {
                for(const key of Object.keys(dataRowObj)) {
                    if((TELSA.moment(dataRowObj[key], 'YYYY-MM-DD', true).isValid()) 
                        || (TELSA.moment(dataRowObj[key], 'YYYY-MM-DD HH:mm:ss', true).isValid())
                        || (TELSA.moment(dataRowObj[key], 'HH:mm:ss', true).isValid())
                        || (TELSA.moment(dataRowObj[key], 'YYYY-MM-DD HH:mm:ssZ', true).isValid())
                        || (TELSA.moment(dataRowObj[key], 'YYYY-WW', true).isValid())) {
                        return key;
                    }
                }
            }
        },

    },

    mounted() {
        let self = this;
        this.$el.addEventListener('mousemove', function(event) {
            self.showDisplayType = true;
            clearTimeout(self.timeoutFunc);
            self.timeoutFunc = setTimeout(function() {
                self.showDisplayType = false;
            }, 1000);
        });
        // this.$el.addEventListener('mouseout', function(event) {
        // });

        let hasPermission = TELSA.checkPermissionQualifier(this.$store.state.user, `reports/run`, this.$props.widgetObj.name, !this.$store.state.batchConfig.product_perms);
        if(hasPermission) {
            this.runReport(false);
        }
        else {
            this.insufficientPermissions = true;
        }
    },

    destroyed() {
        clearTimeout(this.timeoutFunc);
    },

    watch: {
        widgetCommand: {
            handler(newVal, oldVal) {
                if(newVal) {
                    if(newVal.type == 'clearView') {
                        this.clearView();
                    }
                    else if(newVal.type == 'setView') {
                        this.selectedReportView = newVal.value;
                        if(this.gridOptions) {
                            this.applyGridConfig();
                        }
                    }
                    else if(newVal.type == 'setDensity') {
                        if(this.gridSmallMode != (newVal.value == 'Compact')) {
                            this.toggleGridSmallMode();
                        }
                    }
                    else if(newVal.type == 'refresh') {
                        this.runReport(true);
                    }
                    else if(newVal.type == 'resize') {
                        if(this.$props.widgetObj.chartOptions.chart) {
                            this.$props.widgetObj.chartOptions.chart.height = this.$el.parentElement.parentElement.offsetHeight;
                            this.$props.widgetObj.chartOptions.chart.width = this.$el.parentElement.parentElement.offsetWidth;
                        }
                    }
                }
            },
        }
    },

  
};
</script>

<style>

    .report-widget-container {
        height: 100%;
        background-color: #ffffff;
    }

    .report-widget-loading-overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
        z-index: 100;
        text-align: center;
    }
    .report-widget-loading-overlay i {
        animation-name: spin;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        position: absolute !important;
        /* color: rgba(196, 32, 17, 1.3) !important; */
        color: #ffffff !important;
        top: calc(50% - (100px / 2));
        left: calc(50% - (100px / 2));
        font-size: 100px !important;
    }

    .ag-grid-container {
        height: 100%;
    }
    .ag-grid-container.hide {
        display: none;
    }

    .report-chart-settings-container {
        height: 100%;
        padding: 2em;
        background-color: white;
        overflow-y: auto;
        /* color: #000000; */
    }
    .report-chart-settings-container.hide {
        display: none;
    }

    .no-chart-text {
        color: rgba(0,0,0,0.5);
        font-size: 28px;
        text-align: center;
        display: block;
        font-weight: bold;
        position: absolute;
        top: calc(50% - (36px / 1));
        left: calc(50% - (254px / 2));
    }





    /* .report-widget-container .report-show-select-container {
        position: absolute;
        bottom: 20px;
        left: calc(50% - (148px / 2));
        opacity: 0;
    }
    .report-widget-container:hover .report-show-select-container {
        animation: fade-out 0.75s ease-out 3s both;
    }
    .report-widget-container:hover .report-show-select-container:hover {
        opacity: 1 !important;
    } */




    .report-widget-container .report-show-select-container {
        visibility: hidden;
        position: absolute;
        bottom: 20px;
        left: calc(50% - (148px / 2));
        /* visibility: hidden; */

        transition: all 0.3s;
        opacity: 0;
        /* transform: translateY(2000px); */
    }
    .report-widget-container .report-show-select-container.active {
        visibility: visible;

        transition: all 0.3s;
        opacity: 1;
        /* transform: translateY(0px); */
        /* animation: fade-out 0.75s ease-out 3s both; */
    }
    .report-widget-container .report-show-select-container:hover {
        visibility: visible;
        opacity: 1;
    }
    

    .no-backend-data-container {
        position: absolute;
        color: #000000;
        font-size: 24px;
        text-align: center;
        width: 100%;
        top: calc(50%);
    }


    @keyframes fade-out {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            visibility: hidden;
        }
    }


    /* .highcharts-title {
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        50% {
            color: #ff0000;
        }
    } */

    .threshold-exceeded {
        position: absolute;
        text-align: center;
        top: 5px;
        right: 40px;
        animation: blinker 1s linear infinite;
    }
    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }

</style>


